import { useTranslation } from 'react-i18next';
import React from 'react';
import LineChart, { LineChartProps } from '@components/report/chart/line-chart/LineChart';
import TriangleChart, {
	TriangleChartProps,
} from '@components/report/chart/triangle-chart/TriangleChart';
import ReportCard from '@components/report/report-card/ReportCard';
import { threeDivisionGridClass } from '@components/report/style.css';

export interface FollowerGrowthYtProps {
	followerTrend?: LineChartProps;
	followerGrowthRate?: TriangleChartProps;
	followingTrend?: LineChartProps;

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const FollowerGrowthYt = ({
	followerTrend,
	followerGrowthRate,
	followingTrend,

	isLoading,
	isError,
	lackOfPermission,
}: FollowerGrowthYtProps) => {
	const { t } = useTranslation('infReportYoutube');
	const status = { isLoading, isError, lackOfPermission };
	return (
		<div className={threeDivisionGridClass}>
			<ReportCard
				label={t(
					'features.report.section-content.yt.follower-growth-yt.follower-trend.label',
				)}
				tooltip={t(
					'features.report.section-content.yt.follower-growth-yt.follower-trend.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<LineChart
					subDesc={t(
						'features.report.section-content.yt.follower-growth-yt.follower-trend.line-chart.sub-description',
					)}
					data_name_a={t(
						'features.report.section-content.yt.follower-growth-yt.follower-trend.line-chart.follower',
					)}
					desc={true}
					{...status}
					{...followerTrend}
				/>
			</ReportCard>

			<ReportCard
				label={t(
					'features.report.section-content.yt.follower-growth-yt.follower-growth-rate.label',
				)}
				tooltip={t(
					'features.report.section-content.yt.follower-growth-yt.follower-growth-rate.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<TriangleChart desc={true} {...followerGrowthRate} {...status} />
			</ReportCard>

			<ReportCard
				label={t(
					'features.report.section-content.yt.follower-growth-yt.view-trend.label',
				)}
				tooltip={t(
					'features.report.section-content.yt.follower-growth-yt.view-trend.tooltip',
				)}
				lackOfPermission={lackOfPermission}
			>
				<LineChart
					subDesc={t(
						'features.report.section-content.yt.follower-growth-yt.view-trend.line-chart.sub-description',
					)}
					data_name_a={t(
						'features.report.section-content.yt.follower-growth-yt.view-trend.line-chart.views',
					)}
					desc={true}
					{...status}
					{...followingTrend}
				/>
			</ReportCard>
		</div>
	);
};

export default FollowerGrowthYt;
